















import { createComponent, computed } from "@vue/composition-api";
import { BasePrimaryButton } from "@web-components";
import Slider from "@dcc/components/Slider.vue";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

interface SliderPanelProps {
  value: number;
}
export default createComponent({
  props: {
    value: Number
  },
  components: {
    BasePrimaryButton,
    Slider
  },
  setup(props: Readonly<SliderPanelProps>, { emit }) {
    const dictionary = useDictionary();
    const initalValue = props.value;

    const localPercentage = computed({
      get: () => {
        return props.value;
      },
      set: val => {
        emit("input", val);
      }
    });

    const disableButton = computed(() => {
      return props.value === initalValue;
    });

    return {
      localPercentage,
      disableButton,
      initalValue,
      ...dictionary
    };
  }
});
